import { GetUserGroupPermissions } from '.';
import { MenuIcon, RouteKey } from '../../../enum';

export const getUserGroupPermissions: GetUserGroupPermissions = async () => ({
  rules: ['ADMIN', 'DASHBOARD'],
  routes: [
    {
      key: RouteKey.monitoramento,
      path: '/monitoramento',
    },
    {
      key: RouteKey.indicadores,
      path: '/indicadores',
    },
    {
      key: RouteKey.sumario,
      path: '/sumario',
    },
    {
      key: RouteKey.relatorios,
      path: '/relatorios',
    },
  ],
  menu: [
    {
      key: 'monitoramento',
      description: 'Monitoramento',
      icon: MenuIcon.dashboard,
      path: '/monitoramento',
    },
    {
      key: 'indicadores',
      description: 'Indicadores',
      icon: MenuIcon.indicators,
      path: '/indicadores',
    },
    {
      key: 'sumario',
      description: 'Sumario diário',
      icon: MenuIcon.summary,
      path: '/sumario',
    },
    {
      key: 'relatorios',
      description: 'Relatórios',
      icon: MenuIcon.reports,
      path: '/relatorios',
    },
  ],
});

export const getUserGroupPermissions3: GetUserGroupPermissions = async () => ({
  rules: ['ADMIN', 'DASHBOARD'],
  routes: [
    {
      key: RouteKey.monitoramento,
      path: '/monitoramento',
    },
    {
      key: RouteKey.indicadores,
      path: '/indicadores',
    },
    {
      key: RouteKey.sumario,
      path: '/sumario',
    },
    {
      key: RouteKey.relatorios,
      path: '/relatorios',
    },
  ],
  menu: [
    {
      key: 'monitoramento',
      description: 'Monitoramento',
      icon: MenuIcon.dashboard,
      path: '/monitoramento',
    },
    {
      key: 'indicadores',
      description: 'Indicadores',
      icon: MenuIcon.indicators,
      path: '/indicadores',
    },
    {
      key: 'sumario',
      description: 'Sumario diário',
      icon: MenuIcon.summary,
      path: '/sumario',
    },
    {
      key: 'relatorios',
      description: 'Relatórios',
      icon: MenuIcon.reports,
      path: '/relatorios',
    },
  ],
});